import toast from "react-hot-toast";

export const showSuccessToast = (message,options) => {
  toast.success(message, {
    duration: 3000, // default = 3 sec
    ...options,
  });
};


export const showSuccessToast2 = (message) => {
 toast.custom(
  (t) => (
    <div
      style={{
        position: "fixed",
        top: 0,
        left: 0,
        width: "100vw",
        height: "100vh",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        zIndex: 9999,
      }}
    >
      <div
        style={{
          background: "#ffffff",
          color: "#020202",
          padding: "20px",
          borderRadius: "12px",
          textAlign: "center",
          width: "90%",
          maxWidth: "380px",
          // border:"2px solid #020202",
          border: "1px solid #333",
          boxShadow: "0 4px 15px rgba(0,0,0,0.2)"
        }}
      >
        <p style={{ marginBottom: "15px" }}>{message}</p>

        <button  style={{
          background: "#17cc26",
          color: "#fcfcfc",
          
        }} onClick={() => toast.dismiss(t.id)}>
          OK
        </button>
      </div>
    </div>
  ),
  {
    duration: Infinity,
  }
);}
export const showErrorToast = (message) => {
  toast.error(message);
};


export const showCenterErrorToast = (message) => {
  toast.error(message, {
    position: "top-center",

    style: {
      marginTop: "8%",  // pushes toast down
  
    },
  });
};


export const showCustomToast = (message, bgColor = "#333") => {
  toast(message, {
    style: {
      background: bgColor,
      color: "#fff",
    },
  });
};
